import { Heart } from "lucide-react";

import { cn } from "../lib/util.js";

/* 찜 하트. 켜고 끄는 토글이고, 꺼져 있을 때 보일지는 부르는 쪽이 정한다.
   두 자리가 다른 이유:

   - 말풍선(showEmpty): 한 곳을 들여다보는 화면이라 하트가 한 개뿐이다. 빈 하트가
     떠 있어도 시끄럽지 않고, 여기가 표시하기 가장 편한 자리다.
   - 목록: 켜진 것만 그린다. 440줄에 빈 하트가 전부 붙으면 어느 줄이 표시된 곳인지
     하나하나 읽어야 한다 — 훑어서 걸리는 게 목록에서의 하트의 전부다.
     그래서 목록에서 할 수 있는 일은 해제뿐이다.

   <button> 이 아니라 role=button 인 span 이다 — 목록 카드 자체가 <button> 이라 버튼을
   겹쳐 넣을 수 없다(.reviews-open 과 같은 이유). 말풍선에서는 <button> 도 되지만 같은
   마크업을 쓴다. 한 컴포넌트가 두 군데서 다르게 생기면 같은 것인 줄 모른다.

   색은 시트의 하트와 같은 규칙이다 — 켜지면 --primary, 꺼지면 흐린 회색. */
export function WantMark({ on, onToggle, showEmpty, className }) {
  if (!on && !showEmpty) return null;

  const label = on ? "찜 해제" : "찜하기";
  const toggle = (e) => { e.stopPropagation(); onToggle(); };

  return (
    <span
      role="button"
      tabIndex={0}
      aria-pressed={on}
      aria-label={label}
      title={label}
      className={cn(
        "want-mark inline-flex cursor-pointer self-center",
        on ? "text-primary hover:text-primary/50" : "text-muted-foreground hover:text-primary",
        className,
      )}
      onClick={toggle}
      onKeyDown={(e) => {
        if (e.key !== "Enter" && e.key !== " ") return;
        e.preventDefault();
        toggle(e);
      }}
    >
      <Heart aria-hidden="true" className={cn("size-3.5 flex-none", on && "fill-current")} />
    </span>
  );
}
